import { Injectable } from '@angular/core';
import { ICompany, ICompanyExtended, IContact, IContactTypeExtended, ICountry, IRecord } from '../../../../../type_definitions/datatypes';

import { HttpDataService, IHttpDataCache } from '../../../../shared/http/http-data.service';
import { urlUtil } from '../../../../shared/util';

export interface IRole extends IRecord {
  contactType:IContactTypeExtended;
  country:ICountry;
  contact:IContact;
  contactCompany:ICompanyExtended;
  vendor?:ICompany;
  mainContact:boolean;
}

@Injectable()
export class BPProfilesContactsDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public getContactSearchUrl(profileId:number, companyId:number, onlySearchInCountry?:boolean):string {
    const url:string = `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/contacts`;
    return urlUtil.addQueryParams(url, { forBPCountry: onlySearchInCountry });
  }

  public getRoleUrl(profileId:number, roleId:number, companyId:number, vendorCompanyId:number):string {
    let url:string = `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/roles`;
    if (roleId) {
      url += `/${roleId}`;
    }
    return urlUtil.addQueryParams(url, { vendorCompanyId });
  }

  public editContact(profileId:number, companyId:number, contactId:number, data:IContact):Promise<void> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/contacts/${contactId}`,
      undefined,
      data,
      'Saving contact…',
      'Error updating contact'
    );
  }

  public getRoleDefinitions(bpProfileId:number, companyId:number):Promise<IContactTypeExtended[]> {
    return this.cache.doGET(
      `rest/bpprofiles/profiles/${bpProfileId}/companies/${companyId}/roledefinitions`,
      undefined,
      undefined,
      'Error loading role definitions'
    );
  }

  public editContactRole(data:IRole, profileId:number, roleId:number, companyId:number, vendorCompanyId?:number):Promise<IRole> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/roles/${roleId}`,
      { vendorCompanyId },
      data,
      'Saving role…',
      'Error saving role'
    );
  }

  public addContactRole(data:IRole, profileId:number, companyId:number, vendorCompanyId?:number):Promise<IRole> {
    return this.httpDataService.doPOST(
      `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/roles`,
      { vendorCompanyId },
      data,
      'Saving role…',
      'Error adding role'
    );
  }

  public deleteContactRole(profileId:number, roleId:number, companyId:number, vendorCompanyId?:number):Promise<void> {
    return this.httpDataService.doDELETE(
      `rest/bpprofiles/profiles/${profileId}/companies/${companyId}/roles/${roleId}`,
      { vendorCompanyId },
      'Deleting role…',
      'Error deleting role'
    );
  }
}